import { useCreateQuotePhaseMutation } from "@common/api/quoting/quote-phase"
import { currentUserQuery } from "@common/api/users"
import { hasPermission } from "@common/lib/permissions"
import { handleError } from "@common/utils"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import { PhaseNameDialog } from "@/components/phase/phase-name-dialog"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute("/_layout/quotes_/$quoteId/phases/new")({
  beforeLoad: async ({ context: { queryClient }, params, search }) => {
    const me = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(me, "quote:update")) {
      throw redirect({ to: "/quotes/$quoteId", params, search })
    }
  },
  component: NewPhaseDialog,
})

function NewPhaseDialog(): React.ReactElement {
  const { quoteId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const mutation = useCreateQuotePhaseMutation()
  const close = () =>
    navigate({ to: "/quotes/$quoteId", params: { quoteId }, search: true })

  return (
    <PhaseNameDialog
      title="New phase"
      description="Group this quote's tasks by check, such as an A-check or a C-check."
      name=""
      action="Create phase"
      pending={mutation.isPending}
      onSave={(name) =>
        mutation.mutate(
          { quote_id: quoteId, quotePhaseCreate: { name } },
          {
            onSuccess: (phase) => {
              showToast("Created", `${phase.name} added.`, "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
      onCancel={close}
    />
  )
}
